<script lang="ts" setup>
import dayjs from 'dayjs';

defineProps({
  compact: { type: Boolean, default: false },
  title: { type: String, required: true },
  slug: { type: String, required: true },
  description: { type: String, required: true },
  createdAt: { type: String, required: true },
  category: { type: String, required: true },
  cover: { type: String, required: false },
})
</script>
<template>
  <li
    class="card"
  >
    <nuxt-link
    :class="{ 'flex': compact, 'compact-mode': compact, 'flex-col': !compact }"
      class="items-center mb-6"
      :to="`/blog/${slug}`"
    >
      <div class="media lg:mb-6">
        <div class="image-container overflow-hidden">
          <img
            :src="cover"
            onerror="this.onerror=null;this.src='https://assets.terreirovoritadasalmas.com.br/illustrations/default-cover-blank.svg';"
            alt=""
            class="hover:scale-110 transition-all duration-500 cursor-pointer"
          >
        </div>
        <!-- Date -->
        <div class="datetime p-4" v-if="!compact">
          <!-- Day -->
          <span class="text-2xl">{{ $dayjs(createdAt).format('DD') }}</span>
          <span>{{ $dayjs(createdAt).format('MMM') }}</span>
        </div>
      </div>
      <!-- Content -->
      <div class="p-3 lg:p-5 block flex-1">
        <div class="flex gap-3">
          <span class="block lg:mb-2">{{ category }}</span>
          <time v-if="compact" datetime="" class="text-gray-500">
            {{ dayjs(createdAt).format('ll') }}
          </time>
        </div>
        <span class="text-2xl lg:my-3 block hover:underline cursor-pointer font-bold">{{ title }}</span>
        <span class="block lg:my-3 " v-if="!compact">{{ description }}</span>
      </div>
    </nuxt-link>
  </li>
</template>
<style lang="scss" scoped>
.card {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.datetime {
  position: absolute;
  width: 70px;
  bottom: -45px;
  right: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: var(--theme);
  color: #fff;
}

.image-container {
  position: relative;
  max-height: 404px;
  overflow: hidden;
  background-color: #f4f4f4;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.compact-mode {
  .image-container {
    height: 110px;
    width: 110px;
  }
}

.media {
  position: relative;
}

// ----------------------------------------
// Responsive
// ----------------------------------------


@media (screen(lg)) {
  .compact-mode {
    .image-container {
      height: 210px;
      width: 210px;
    }
  }
}
</style>